<ng-container [formGroup]='targetingForm'>
  <hr class='subDivider' *ngIf="!hideBorder">
  <h3 *ngIf="!hideBorder">{{ 'campaign.siteGroup.title' | translate }}</h3>
  <div formArrayName='siteGroupTargets' class='d-flex flex-column align-items-center'>
    <div class='mb-1'>
      <span [innerHTML]="'campaign.siteGroup.descriptionPrefix' | translate"></span><strong
      *ngIf='selectedSiteGroups() as selectedList'><span
      *ngIf='selectedList.length === 0'>{{ 'campaign.siteGroup.any' | translate }}</span><span
      *ngIf='selectedList.length > 0'><span
      *ngFor='let selectedItem of selectedList; let isLast=last'>{{ selectedItem }}<span
      *ngIf='!isLast' translate='grammar.listSeparator'></span> </span></span></strong>
    </div>
    <ul class="list-unstyled mb-0" style="column-count: 3">
      <li *ngFor='let option of options; let i = index' [openDelay]="600" [popoverTitle]="option.popoverTitle" [ngbPopover]="option.popoverDescription" triggers="mouseenter:mouseleave">
        <span *ngIf="'siteGroupTarget_'+uuid+i as id" class='form-check form-check-inline'>
          <input class='form-check-input' type='checkbox' [formControlName]='option.controlIndex' [id]='id'/>
          <label class='form-check-label' [for]='id'>
            {{ option.name }}
          </label>
        </span>
      </li>
    </ul>
    <div *ngIf="siteUrls.length > 0" class="row align-items-center">
      <div class="col-auto">
        {{ 'campaign.siteGroup.details' | translate: {count: siteUrls.length} }}
      </div>
      <div class="col-auto mt-2">
        <div class="form-check small">
          <input type="checkbox" [formControl]="showAllControl" class="form-check-input" [id]="'showAll' + uuid">
          <label class="form-check-label" [for]="'showAll' + uuid">{{ 'campaign.siteGroup.showAll' | translate }}</label>
        </div>
      </div>
    </div>
    <div class="row align-items-center small" *ngIf="showSites">
      <ul class="mb-2" style="column-count: 3">
        <li *ngFor="let siteUrl of siteUrls; let i = index">{{ siteUrl }}</li>
      </ul>
    </div>
    <div class='form-text mt-0'>{{ 'campaign.siteGroup.instructions' | translate }}</div>
  </div>
</ng-container>
